import {Injectable} from '@angular/core';
import {User} from '../../interfaces/User';
import {Pagination} from '../../../utilities/interfaces/Pagination';
import {AuthHttp} from '../auth/http/auth-http.service';
import {environment} from '../../../../../environments/environment';

@Injectable()
export class ArchivedUsersService {
  private route = 'users/archived';

  constructor(private http: AuthHttp) {
  }

  /**
   * Retrieves the archived users
   * @param {number} limit
   * @param {number} page
   * @param {string} name
   * @return {Promise<Pagination<User>>}
   */
  public getUsers(limit: number = 10, page = 1, name: string = ''): Promise<Pagination<User>> {
    return this.http.get(`${environment.baseUrl}${this.route}?limit=${limit}&page=${page}&name=${name}`)
      .map((res) => res.json()).toPromise();
  }

  /**
   * Restores an archived user
   * @param {number} id
   * @return {Promise<any>}
   */
  public restore(id: number) {
    return this.http.put(`${environment.baseUrl}${this.route}/${id}`, '').toPromise();
  }

}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/user/services/archived-users/archived-users.service.ts